module.exports = __webpack_public_path__ + "img/credit-one-club-gal-6.45eb3cae.jpg";